module.exports = __webpack_public_path__ + "img/Group_27912.bfe27981.svg";